import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Models
import mInstallation from 'models/installation';
// Custom
import { entityDataShape } from 'constants/PropTypesShapes';
import { getHocDisplayName } from 'utils/Tools';

const withEntitiesInformation = (WrappedComponent) => {
  const WithEntitiesInformation = ({
    hasMasterEntity, hasMultipleEntities, hasHostOpBookingsEntity, defaultEntity, ...otherProps
  }) => (
    <WrappedComponent
      hasMasterEntity={hasMasterEntity}
      hasMultipleEntities={hasMultipleEntities}
      hasHostOpBookingsEntity={hasHostOpBookingsEntity}
      defaultEntity={defaultEntity}
      {...otherProps}
    />
  );

  WithEntitiesInformation.displayName = getHocDisplayName('WithEntitiesInformation', WrappedComponent);

  WithEntitiesInformation.propTypes = {
    hasMasterEntity: PropTypes.bool.isRequired,
    hasMultipleEntities: PropTypes.bool.isRequired,
    hasHostOpBookingsEntity: PropTypes.bool.isRequired,
    defaultEntity: entityDataShape.isRequired,
  };

  const mapStateToProps = (state) => ({
    hasMasterEntity: mInstallation.hasMasterEntity(state.installation.current.data),
    hasHostOpBookingsEntity: mInstallation.hasHostOpBookingsEntity(state.installation.current.data),
    hasMultipleEntities: _size(_get(state.installation.current.data, 'entities')) > 1,
    defaultEntity: mInstallation.defaultEntity(state.installation.current.data),
  });

  return connect(
    mapStateToProps,
  )(WithEntitiesInformation);
};

export default withEntitiesInformation;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/hocs/WithEntitiesInformation.js